import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { Observable, ReplaySubject, Subject, take, takeUntil } from 'rxjs';
import {
  Country,
  Gender,
  MaritalStatus,
  Occupation,
  UpdateDataTokenCode,
} from 'src/app/shared/class/update-data';
import { DataSelects, State } from 'src/app/shared/interfaces/data-selects';
import { StepMoreInformation } from 'src/app/shared/interfaces/step-data';
import { RequestInformationComponent } from 'src/app/shared/request-information/request-information.component';
import { GetDataService } from 'src/app/shared/services/get-data.service';
import { PutDataService } from 'src/app/shared/services/put-data.service';
import { RequestFormService } from 'src/app/shared/services/request-form.service';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';
import { FormsValidators } from 'src/app/shared/utils/forms-validators';

@Component({
  selector: 'app-step-mas-informacion-lto',
  templateUrl: './step-mas-informacion-lto.component.html',
  styleUrls: ['./step-mas-informacion-lto.component.scss'],
})
export class StepMasInformacionLtoComponent
  extends AutoUnsubscribeComponent
  implements OnInit {
  @Input() saveRequest!: Observable<boolean>;
  @Input() dataMoreInformationLto!: DataSelects;
  @Output() formValidEvent = new EventEmitter<boolean>();
  @Output() stepMoreInformationLtoSavedEvent = new EventEmitter<boolean>();
  @ViewChild('singleSelect') singleSelect!: MatSelect;

  public formStepMoreInformationLto!: FormGroup;
  protected _onDestroy = new Subject<void>();

  public selectedState: String = '';

  public gender: Gender[] = [];
  public countries: Country[] = [];
  public stateArray: State[] = [];
  public countryCtrl: FormControl = new FormControl();
  public stateCtrl: FormControl = new FormControl();
  public statesFilterCtrl: FormControl = new FormControl();
  public filteredStates: ReplaySubject<State[]> = new ReplaySubject<State[]>(1);
  public maritalStatusList: MaritalStatus[] = [];
  public activities: Occupation[] = [];
  public hideButton = true;
  public isOpen = false;
  public docId!: string;
  public numberRequest!: string;
  public creditTypeUpdate!: string;
  public codePostal!: any;
  public colonies: State[] = [];

  constructor(
    private frmBuilder: FormBuilder,
    private requestFormService: RequestFormService,
    private putDataService: PutDataService,
    public dialog: MatDialog,
    private router: Router,
    private getDataService: GetDataService
  ) {
    super();

    const CURP = /^[0-9üñça-zÜÑÇA-Z]{10}[H|Mh|m]{1}[0-9üñça-zÜÑÇA-Z]{7}$/;
    const RFC = /^[0-9a-zA-Z]{13}$/;
    const POSTALCODE = /^[0-9]{5}$/;
    const NUMEXT = /^([a-zA-Z0-9]+\s*)*[a-zA-Z0-9]+$/;

    this.formStepMoreInformationLto = this.frmBuilder.group({
      curp: ['', [Validators.required, Validators.pattern(CURP)]],
      gender: ['', [Validators.required]],
      countryOfBirthCode: ['', [Validators.required]],
      maritalStatus: ['', [Validators.required]],
      rfc: ['', [Validators.required, Validators.pattern(RFC)]],
      ine: [
        '',
        [
          Validators.required,
          Validators.minLength(13),
          Validators.maxLength(18),
        ],
      ],
      occupationId: ['', [Validators.required]],
      otherOccupation: ['', [Validators.maxLength(45)]],
      postalCodeId: [
        '',

        [Validators.required, Validators.pattern(POSTALCODE)],
      ],
      street: [
        '',

        [Validators.required, Validators.maxLength(50)],
      ],
      externalNumber: [
        '',

        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern(NUMEXT),
        ],
      ],
      internalNumber: [
        '',

        [Validators.maxLength(10), Validators.pattern(NUMEXT)],
      ],
      colonyId: [
        '',

        [Validators.required],
      ],
      stateId: [
        '',

        [Validators.required],
      ],
      municipalityId: [
        '',

        [Validators.required, Validators.maxLength(45)],
      ],
    });
    this.stateCtrl.setValidators([Validators.required]);
  }

  ngOnInit(): void {
    this.saveRequest.subscribe((value) => {
      if (value) {
        if (this.formStepMoreInformationLto.dirty) {
          this.saveStepMoreInformation();
        } else {
          this.openRequestInformationDialog();
        }
      }
    });

    this.requestFormService.getDataFormObservable().subscribe(() => {
      this.loadUpdateFormStepMoreInformation();
    });

    if (this.requestFormService.getDataForm().requestNumber) {
      this.loadUpdateFormStepMoreInformation();
      //  this.formStepMoreInformationLto.controls['curp'].disable();
    }

    this.statesFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        if (this.statesFilterCtrl.value) {
          this.filterStates();
        }
      });
  }

  selectionCountry(country: string, { isUserInput }: MatOptionSelectionChange) {
    if (
      isUserInput ||
      this.requestFormService.getUpdateForm().aboutYou?.stateOfBirth
    ) {
      this.filteredStates.next(
        this.stateArray.filter((state) => state.countryCode == country)
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataMoreInformationLto']?.currentValue) {
      this.stateArray = this.dataMoreInformationLto.states;
      this.countries = this.dataMoreInformationLto.countries;
      this.gender = this.dataMoreInformationLto.genders;
      this.maritalStatusList = this.dataMoreInformationLto.maritalStatus.sort(
        (a, b) => a.name.localeCompare(b.name)
      );
      this.activities = this.dataMoreInformationLto.occupations
        .filter((ocu) => ocu.name != 'Otra')
        .sort((a, b) => a.name.localeCompare(b.name));
      const activityOther = this.dataMoreInformationLto.occupations.find(
        (act) => act.name == 'Otra'
      );
      if (activityOther) {
        this.activities.push(activityOther);
      }

      const occupations = this.dataMoreInformationLto.occupations.find(
        (occ) => occ.name == 'Transporte de Aplicación'
      );
      if (occupations) {
        this.formStepMoreInformationLto.controls['occupationId'].setValue(
          occupations.id
        );
      }

      this.checkEvent();
      this.filteredStates.next(this.stateArray.slice());
    }
  }

  checkEvent() {
    this.formValidEvent.emit(
      this.formStepMoreInformationLto.valid &&
      !this.stateCtrl.invalid &&
      !this.formStepMoreInformationLto.get('curp')?.invalid
    );
  }

  protected setInitialValueStates() {
    this.filteredStates
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        this.singleSelect.compareWith = (a: State, b: State) =>
          a && b && a.id === b.id;
      });
  }

  protected filterStates() {
    const countrySelected =
      this.formStepMoreInformationLto.value.countryOfBirthCode === 'MX'
        ? 'MX'
        : 'EX';
    if (!this.stateArray) {
      return;
    }

    const search = this.statesFilterCtrl.value?.toLowerCase();
    if (!search) {
      this.filteredStates.next(this.stateArray.slice());
      return;
    }

    this.filteredStates.next(
      this.stateArray
        .filter((state) => state.name.toLowerCase().indexOf(search) > -1)
        .filter((state) => state.countryCode == countrySelected)
    );
  }

  getStepMoreInformationObject(): StepMoreInformation {
    return {
      ...this.formStepMoreInformationLto.value,
      stateOfBirthId: this.stateCtrl.value,
      stateId: this.codePostal.state.id,
      postalCodeId: this.codePostal.id,
      municipalityId: this.codePostal.municipality.id,
    };
  }

  saveStepMoreInformation() {
    if (this.formStepMoreInformationLto.valid && this.stateCtrl.valid) {
      const putUpdateMoreInformationLto$ = this.putDataService
        .putUpdateMoreInformationLto(
          this.getCountry().toUpperCase(),
          this.getApplicationId(),
          this.getStepMoreInformationObject()
        )
        .subscribe({
          next: () => {
            this.openRequestInformationDialog();
            this.hideButton = false;
          },
          error: (err) => {
            this.openRequestInformationErrorDialog(err);
          },
        });
      this.subscriptions.push(putUpdateMoreInformationLto$);
    } else {
      FormsValidators.markFormGroupTouched(this.formStepMoreInformationLto);
    }
  }

  validInputOtherOccupation({ isUserInput, source }: MatOptionSelectionChange) {
    if (!isUserInput) {
      return;
    }

    const otherOcuppationValidators =
      source.value == '46b404ff-8e58-4834-b292-8effce96e94a'
        ? [Validators.required]
        : [];

    this.formStepMoreInformationLto.controls['otherOccupation'].setValidators(
      otherOcuppationValidators
    );

    this.formStepMoreInformationLto.controls[
      'otherOccupation'
    ].updateValueAndValidity();
  }

  openRequestInformationDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Su solicitud se guardó con exito',
      question: `Gracias por completar el formulario, nos pondremos en contacto con usted a la brevedad.`,
    };
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => {
        this.router.navigate(['/busqueda']);
        sessionStorage.clear();
      });
  }

  openRequestInformationErrorDialog(event: HttpErrorResponse) {
    let errorMessage = 'Ha ocurrido un error.';

    const errorCurpInUse = `CURP_IN_USE`.match(event?.error.errors[0].code);

    if (event.status === 400) {
      errorMessage = `Debe completar los campos requeridos.`;
    }

    if (event.status === 409 && errorCurpInUse) {
      errorMessage = `Ya ha sido realizada una solicitud con el CURP que nos proporcionaste.
      \nSi desea retomar una solicitud, puede hacerlo desde la sección de BUSCAR SOLICITUD con su correo electrónico y número de solicitud.`;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Información de solicitud',
      question: errorMessage,
    };
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  loadUpdateFormStepMoreInformation() {
    this.buildForm(this.requestFormService.getUpdateForm());
    this.stateCtrl.setValue(
      this.requestFormService.getUpdateForm().moreInformation.stateOfBirth.id
    );
    this.checkEvent();
  }

  buildForm(value: UpdateDataTokenCode) {
    this.getPostalCode(value.validation.postalCodeId?.number);
    if (
      value.moreInformation.curp != null &&
      value.moreInformation.ine != null
    ) {
      this.formStepMoreInformationLto.patchValue({
        curp: value.moreInformation.curp,
        gender: value.moreInformation.gender,
        countryOfBirthCode: value.moreInformation.countryOfBirthCode?.code,
        maritalStatus: value.moreInformation.maritalStatus,
        rfc: value.moreInformation.rfc,
        ine: value.moreInformation.ine,
        occupationId: value.moreInformation.occupation?.id,
        otherOccupation: value.moreInformation.otherOccupation,
        postalCodeId: value.validation.postalCodeId?.number,
        street: value.validation.street,
        externalNumber: value.validation.externalNumber,
        internalNumber: value.validation.internalNumber,
        colonyId: value.validation.colony?.id,
        stateId: value.validation.state?.id,
        municipalityId: value.validation.municipality?.id,
      });
    } else {
      this.formStepMoreInformationLto.patchValue({
        curp: value.validation.scannedDataResponse.curp,

        ine: value.validation.scannedDataResponse.ine,
      });
    }
  }

  isLetterAndNumber(evt: KeyboardEvent) {
    const pattern = /^[0-9a-zA-Z]+$/;
    return pattern.test(evt.key);
  }

  deleteSpaceInit(evt: KeyboardEvent) {
    evt.target?.addEventListener('keyup', (e: any) => {
      const string = e.target!.value;
      e.target.value = string.trimStart();
    });
  }

  getPreviousPostalCode(event: any) {
    this.getPostalCode(event.target.value);
  }

  getPostalCode(event: string) {
    const getPostalCodeLtoMX$ = this.getDataService
      .getPostalCodeLtoMX(this.getCountry().toUpperCase(), event)
      .subscribe((resp) => {
        this.colonies = resp.colonies;
        this.formStepMoreInformationLto
          .get('stateId')
          ?.setValue(resp.state.name);
        this.formStepMoreInformationLto
          .get('municipalityId')
          ?.setValue(resp.municipality.name);
        this.codePostal = {
          state: resp.state,
          municipality: resp.municipality,
          id: resp.id,
        };
      });
    this.subscriptions.push(getPostalCodeLtoMX$);
  }

  getCountry() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('language')!
      : this.requestFormService.getUpdateForm().countryCode.code.toLowerCase();
  }

  getApplicationId() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('applicationId')!
      : this.requestFormService.getUpdateForm().id;
  }
}
